module.exports = __webpack_public_path__ + "static/media/Ondernemersfonds Utrecht logo.81dbbddf.jpg";